import React, { useEffect } from "react";

import Conclusions from "portfolio/components/Conclusions";

const selectedStyle = {
  textAlign: "center",
  backgroundColor: "#eff1ff",
  fontWeight: "bold",
};
const nonSelectedStyle = { textAlign: "center" };
const mainColor = "#3e51b5";

const ReportPreview = (props) => {
  const { actions, portfolio, portfolioEntry } = props;

  const { reportPreview } = portfolioEntry;

  useEffect(() => {
    if (!reportPreview) {
      actions.loadPreview(portfolio);
    }
  }, []);

  return (
    <div>
      {reportPreview && reportPreview.isLoading && (
        <div>
          <div>Loading...</div>
        </div>
      )}
      {reportPreview && !reportPreview.isLoading && (
        <div>
          <Conclusions portfolio={reportPreview.data} isPreview={true} />
        </div>
      )}
    </div>
  );
};

const Render = ReportPreview;

function isComplete() {
  return true;
}

const Description = () => <div></div>;

const Preview = (props) => {
  const { portfolio } = props;
  return <div></div>;
};

export { isComplete, Render, Description, Preview };



// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/components/ReportPreview.js